import OriginSystem from '../origin/origin-system.entity';

export default class WorkItem {
  id: string;

  project: string;

  originSystem: OriginSystem;

  workItemType: string;

  title: string;

  description: string;

  createdBy: string;

  assignedTo: string;

  estimatedDeadLine: Date;

  concludedAt: Date;

  originalEstimate: Number;

  storyPoints?: number;

  statusDate: Date;

  workItemNumber: Number;

  status: string;

  createdDate: Date;

  originCreatedDate: Date;

  effortSpent: number;

  parentNumber?: Number;

  childs?: WorkItem[];

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.project = obj.project || '';
    this.originSystem = obj.originSystem || '';
    this.workItemType = obj.workItemType || '';
    this.title = obj.title || '';
    this.description = obj.description || '';
    this.createdBy = obj.createdBy || '';
    this.assignedTo = obj.assignedTo || '';
    this.estimatedDeadLine = obj.estimatedDeadLine || '';
    this.concludedAt = obj.concludedAt || '';
    this.originalEstimate = obj.originalEstimate || '';
    this.storyPoints = obj.storyPoints;
    this.statusDate = obj.statusDate || '';
    this.workItemNumber = obj.workItemNumber || '';
    this.status = obj.status || 'OPEN';
    this.createdDate = obj.createdDate || '';
    this.originCreatedDate = obj.originCreatedDate || '';
    this.effortSpent = obj.effortSpent || 0;
    this.parentNumber = obj.parentNumber || '';
    if (obj.childs) {
      this.childs = WorkItem.ofList(obj.childs);
    }
  }

  get numberAndTitle() {
    return `${this.workItemNumber} - ${this.title}`;
  }

  public static of(value: any): WorkItem {
    return new WorkItem(value || {});
  }

  public static ofList(response: any): WorkItem[] {
    return response.map(this.of);
  }
}
